<template>
  <div class="profile">
    <div class="profile-panel">
      <span>{{ t['my_account'] }}</span>
      <nav>
        <router-link @click="$root.track($root.events.NAVIGATION, { properties: { event_label: 'saved_searches_my_profile' } })" data-test-id="my_searches" aria-label="my saved searches link" to="/min/mine-soegninger">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#CCE1FF" />
            <path d="M18.6719 16.8906L15.3906 13.6094C16.1289 12.5156 16.5117 11.1484 16.3203 9.67188C15.9648 7.15625 13.9141 5.13281 11.4258 4.80469C7.70703 4.33984 4.5625 7.48438 5.02734 11.2031C5.35547 13.6914 7.37891 15.7422 9.89453 16.0977C11.3711 16.2891 12.7383 15.9062 13.8594 15.168L17.1133 18.4492C17.5508 18.8594 18.2344 18.8594 18.6719 18.4492C19.082 18.0117 19.082 17.3281 18.6719 16.8906ZM7.16016 10.4375C7.16016 8.52344 8.71875 6.9375 10.6602 6.9375C12.5742 6.9375 14.1602 8.52344 14.1602 10.4375C14.1602 12.3789 12.5742 13.9375 10.6602 13.9375C8.71875 13.9375 7.16016 12.3789 7.16016 10.4375Z" fill="#0068FF" />
          </svg>
          <span>{{ t['my_searches'] }}</span>
        </router-link>
        <router-link @click="$root.track($root.events.NAVIGATION, { properties: { event_label: 'favorites_my_profile' } })" data-test-id="my_favorites" aria-label="my favorites link" to="/min/favoritter">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#CCE1FF" />
            <path d="M17.9062 12.1602L12.6289 17.6016C12.4466 17.7839 12.237 17.875 12 17.875C11.763 17.875 11.5534 17.7839 11.3711 17.6016L6.09375 12.1602C5.32812 11.3216 4.96354 10.3555 5 9.26172C5.03646 8.1862 5.48307 7.25651 6.33984 6.47266C7.1237 5.83464 7.98958 5.55208 8.9375 5.625C9.90365 5.71615 10.7422 6.11719 11.4531 6.82812L12 7.375L12.5469 6.82812C13.2578 6.11719 14.0872 5.71615 15.0352 5.625C16.0013 5.55208 16.8763 5.83464 17.6602 6.47266C18.5169 7.25651 18.9635 8.1862 19 9.26172C19.0365 10.3372 18.6719 11.3034 17.9062 12.1602Z" fill="#0068FF" />
          </svg>
          <span>{{ t['my_favorites'] }}</span>
        </router-link>
        <router-link @click="$root.track($root.events.NAVIGATION, { properties: { event_label: 'tradeins_my_profile' } })" data-test-id="my_tradeins" aria-label="my trade-ins link" to="/min/byttebil">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#D9D9D9" />
            <g clip-path="url(#clip0_750_99)">
              <path
                d="M6.47062 7.04805C6.5325 6.87031 6.70406 6.75 6.89813 6.75H10.8019C10.9959 6.75 11.1675 6.87031 11.2294 7.04805L11.7272 8.5H5.97281L6.47062 7.04805ZM4.01531 8.675C3.41625 8.95664 3 9.55547 3 10.25V12.875V13.75C3 14.234 3.40219 14.625 3.9 14.625H4.35C4.84781 14.625 5.25 14.234 5.25 13.75V12.875H9.08906C9.2325 12.7191 9.39281 12.5824 9.57 12.4621L10.2112 10.5945C10.6387 9.34492 11.8425 8.5 13.2009 8.5H13.6256L12.9366 6.4957C12.63 5.60156 11.7694 5 10.8019 5H6.89813C5.93063 5 5.07 5.60156 4.76344 6.4957L4.01531 8.675ZM4.575 10.6875C4.575 10.5135 4.64612 10.3465 4.7727 10.2235C4.89929 10.1004 5.07098 10.0312 5.25 10.0312C5.42902 10.0312 5.60071 10.1004 5.7273 10.2235C5.85388 10.3465 5.925 10.5135 5.925 10.6875C5.925 10.8615 5.85388 11.0285 5.7273 11.1515C5.60071 11.2746 5.42902 11.3438 5.25 11.3438C5.07098 11.3438 4.89929 11.2746 4.7727 11.1515C4.64612 11.0285 4.575 10.8615 4.575 10.6875ZM13.1981 11.125H17.1019C17.2959 11.125 17.4675 11.2453 17.5294 11.423L18.0272 12.875H12.2728L12.7706 11.423C12.8325 11.2453 13.0041 11.125 13.1981 11.125ZM11.0634 10.8707L10.3153 13.05C9.71625 13.3316 9.3 13.9305 9.3 14.625V17.25V18.125C9.3 18.609 9.70219 19 10.2 19H10.65C11.1478 19 11.55 18.609 11.55 18.125V17.25H18.75V18.125C18.75 18.609 19.1522 19 19.65 19H20.1C20.5978 19 21 18.609 21 18.125V17.25V14.625C21 13.9305 20.5838 13.3316 19.9847 13.05L19.2366 10.8707C18.93 9.97656 18.0694 9.375 17.1019 9.375H13.1981C12.2306 9.375 11.37 9.97656 11.0634 10.8707ZM11.55 14.4062C11.729 14.4062 11.9007 14.4754 12.0273 14.5985C12.1539 14.7215 12.225 14.8885 12.225 15.0625C12.225 15.2365 12.1539 15.4035 12.0273 15.5265C11.9007 15.6496 11.729 15.7188 11.55 15.7188C11.371 15.7188 11.1993 15.6496 11.0727 15.5265C10.9461 15.4035 10.875 15.2365 10.875 15.0625C10.875 14.8885 10.9461 14.7215 11.0727 14.5985C11.1993 14.4754 11.371 14.4062 11.55 14.4062ZM18.075 15.0625C18.075 14.8885 18.1461 14.7215 18.2727 14.5985C18.3993 14.4754 18.571 14.4062 18.75 14.4062C18.929 14.4062 19.1007 14.4754 19.2273 14.5985C19.3539 14.7215 19.425 14.8885 19.425 15.0625C19.425 15.2365 19.3539 15.4035 19.2273 15.5265C19.1007 15.6496 18.929 15.7188 18.75 15.7188C18.571 15.7188 18.3993 15.6496 18.2727 15.5265C18.1461 15.4035 18.075 15.2365 18.075 15.0625Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_750_99">
                <rect width="18" height="14" fill="white" transform="translate(3 5)" />
              </clipPath>
            </defs>
          </svg>
          <span>{{ t['my_tradeins'] }}</span>
        </router-link>
        <router-link @click="$root.track($root.events.NAVIGATION, { properties: { event_label: 'orders_my_profile' } })" data-test-id="my_orders" aria-label="my orders link" to="/min/ordrer" v-if="$root.user">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#CCE1FF" />
            <path d="M16.6602 16.125C16.2956 16.1432 15.9948 16.2708 15.7578 16.5078C15.5026 16.763 15.375 17.0729 15.375 17.4375C15.3932 17.8021 15.5208 18.112 15.7578 18.3672C15.9948 18.6042 16.2956 18.7318 16.6602 18.75C17.0247 18.7318 17.3255 18.6042 17.5625 18.3672C17.8177 18.112 17.9453 17.8021 17.9453 17.4375C17.9453 17.0729 17.8268 16.763 17.5898 16.5078C17.3529 16.2708 17.043 16.1432 16.6602 16.125ZM8.78516 16.125C8.42057 16.1432 8.11979 16.2708 7.88281 16.5078C7.6276 16.763 7.5 17.0729 7.5 17.4375C7.51823 17.8021 7.64583 18.112 7.88281 18.3672C8.11979 18.6042 8.42057 18.7318 8.78516 18.75C9.14974 18.7318 9.45052 18.6042 9.6875 18.3672C9.94271 18.112 10.0703 17.8021 10.0703 17.4375C10.0703 17.0729 9.95182 16.763 9.71484 16.5078C9.47786 16.2708 9.16797 16.1432 8.78516 16.125ZM19.5859 5.98047C19.4036 5.74349 19.1667 5.625 18.875 5.625H7.30859L7.28125 5.29688C7.1901 4.95052 6.97135 4.76823 6.625 4.75H4.62891C4.24609 4.78646 4.03646 4.99609 4 5.37891C4 5.5612 4.0638 5.71615 4.19141 5.84375C4.31901 5.98958 4.46484 6.0625 4.62891 6.0625H6.05078L7.71875 14.7305C7.8099 15.0586 8.02865 15.2318 8.375 15.25H17.3438C17.7448 15.2135 17.9635 15.0039 18 14.6211C17.9635 14.2018 17.7448 13.974 17.3438 13.9375H8.92188L8.67578 12.625H17.3711C17.7904 12.6068 18.0729 12.3971 18.2188 11.9961L19.7227 6.77344C19.7956 6.46354 19.75 6.19922 19.5859 5.98047Z" fill="#0068FF" />
          </svg>
          <span>{{ t['my_orders'] }}</span>
        </router-link>
        <router-link @click="$root.track($root.events.NAVIGATION, { properties: { event_label: 'my_account_my_profile' } })" data-test-id="account_settings" aria-label="account settings" data-tes to="/min/konto" v-if="$root.user">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#CCE1FF" />
            <path
              d="M18.6719 13.8281C18.6536 13.6641 18.5716 13.5365 18.4258 13.4453L17.168 12.707C17.2227 12.3789 17.25 12.0599 17.25 11.75C17.25 11.4401 17.2227 11.1211 17.168 10.793L18.4258 10.0547C18.5716 9.96354 18.6445 9.83594 18.6445 9.67188C18.6445 9.52604 18.5443 9.23438 18.3438 8.79688C18.1432 8.3776 17.9062 7.97656 17.6328 7.59375C17.3594 7.19271 17.1224 6.98307 16.9219 6.96484C16.8307 6.96484 16.7487 6.98307 16.6758 7.01953L15.418 7.75781C14.9258 7.33854 14.3698 7.01953 13.75 6.80078V5.32422C13.7318 5.10547 13.6133 4.95964 13.3945 4.88672C12.957 4.79557 12.4922 4.75 12 4.75C11.5078 4.75 11.043 4.79557 10.6055 4.88672C10.3867 4.95964 10.2682 5.10547 10.25 5.32422V6.80078C9.63021 7.01953 9.07422 7.33854 8.58203 7.75781L7.32422 7.01953C7.2513 6.98307 7.16927 6.96484 7.07812 6.96484C6.89583 6.98307 6.66797 7.18359 6.39453 7.56641C6.12109 7.93099 5.88411 8.33203 5.68359 8.76953C5.46484 9.1888 5.35547 9.48958 5.35547 9.67188C5.35547 9.83594 5.42839 9.96354 5.57422 10.0547L6.83203 10.793C6.77734 11.1029 6.75 11.4219 6.75 11.75C6.75 12.0781 6.77734 12.3971 6.83203 12.707L5.57422 13.4453C5.42839 13.5365 5.35547 13.6641 5.35547 13.8281C5.35547 13.974 5.45573 14.2656 5.65625 14.7031C5.85677 15.1224 6.09375 15.5234 6.36719 15.9062C6.64062 16.3073 6.8776 16.5169 7.07812 16.5352C7.16927 16.5352 7.2513 16.5169 7.32422 16.4805L8.58203 15.7422C9.07422 16.1615 9.63021 16.4805 10.25 16.6992V18.1758C10.2682 18.3945 10.3867 18.5404 10.6055 18.6133C11.0612 18.7044 11.5169 18.75 11.9727 18.75C12.4466 18.75 12.9206 18.7044 13.3945 18.6133C13.6133 18.5221 13.7318 18.3763 13.75 18.1758V16.6992C14.3698 16.4805 14.9258 16.1615 15.418 15.7422L16.6758 16.4805C16.7487 16.5169 16.8307 16.5352 16.9219 16.5352C17.1042 16.5169 17.332 16.3164 17.6055 15.9336C17.8789 15.569 18.1159 15.168 18.3164 14.7305C18.5352 14.3112 18.6536 14.0104 18.6719 13.8281ZM12 13.9375C11.3802 13.9193 10.8607 13.7096 10.4414 13.3086C10.0404 12.8893 9.83073 12.3698 9.8125 11.75C9.83073 11.1302 10.0404 10.6107 10.4414 10.1914C10.8607 9.79036 11.3802 9.58073 12 9.5625C12.6198 9.58073 13.1393 9.79036 13.5586 10.1914C13.9596 10.6107 14.1693 11.1302 14.1875 11.75C14.1693 12.3698 13.9596 12.8893 13.5586 13.3086C13.1393 13.7096 12.6198 13.9193 12 13.9375Z"
              fill="#0068FF"
            />
          </svg>
          <span>{{ t['account_settings'] }}</span>
        </router-link>
        <button @click="logout" v-if="$root.user">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" width="24" height="24" rx="4" fill="#D02E26" fill-opacity="0.5" />
            <path d="M7.625 17.875H9.375C9.83984 17.875 10.25 17.4922 10.25 17C10.25 16.5352 9.83984 16.125 9.375 16.125H7.625C7.13281 16.125 6.75 15.7422 6.75 15.25V8.25C6.75 7.78516 7.13281 7.375 7.625 7.375H9.375C9.83984 7.375 10.25 6.99219 10.25 6.5C10.25 6.03516 9.83984 5.625 9.375 5.625H7.625C6.14844 5.625 5 6.80078 5 8.25V15.25C5 16.6992 6.14844 17.875 7.625 17.875ZM18.7812 11.2852L14.8438 7.56641C14.6523 7.375 14.3789 7.34766 14.1328 7.42969C13.8867 7.53906 13.75 7.78516 13.75 8.03125V10H10.25C9.75781 10 9.375 10.4102 9.375 10.875V12.625C9.375 13.1172 9.75781 13.5 10.25 13.5H13.75V15.4688C13.75 15.7148 13.8867 15.9609 14.1328 16.0703C14.3789 16.1523 14.6523 16.125 14.8438 15.9336L18.7812 12.2148C19.0547 11.9961 19.0547 11.5312 18.7812 11.2852Z" fill="#D02E26" />
          </svg>
          <span>{{ t['logout'] }}</span>
        </button>
      </nav>
    </div>
    <router-view class="profileSection" />
  </div>
</template>

<script>
import { PROFILE } from '../../lib/constants'

export default {
  name: 'ProfilePage',
  computed: {
    t() {
      return PROFILE
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$root.track('view_my_profile')
    })
  },
  methods: {
    logout() {
      this.$root.track(this.$root.events.LOGOUT)
      window.seezSdk.showLogout()
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/base.scss';

.profile-panel {
  border-right: 1px solid #efefef;
  padding-right: 1em;
  padding: 0 1rem;
  position: relative;

  @media screen and (min-width: 53.438rem) {
    display: grid;
    align-content: flex-start;
    min-height: 100vh;
  }

  > span {
    grid-area: 1 / 1;
    font-size: 1.875rem;
    font-weight: 400;
    margin: 1em 1em 0.5em 0;
    text-align: left;
    color: var(--dark-gray-90);
    padding: 0 1rem;
    display: none;

    @media screen and (min-width: 53.438rem) {
      display: block;
    }
  }

  > nav {
    grid-area: 2 / 1;
    align-self: start;
    gap: 0.25em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: var(--light-gray);
    position: fixed;
    z-index: 2;
    box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.06);
    border-radius: 14px;
    max-width: 90%;
    margin: auto;
    width: 100%;
    bottom: 0.5rem;
    left: 0;
    right: 0;

    @media screen and (min-width: 53.438rem) {
      display: grid;
      position: initial;
      background-color: white;
      border-radius: 0;
      z-index: 0;
      box-shadow: none;
      max-width: none;
      margin: 0;
    }

    > a {
      color: var(--font1);
      text-decoration: none;
      position: relative;
      border-radius: 12px;
      display: flex;
      gap: 1em;
      align-items: center;
      margin: 0.3rem;

      @media screen and (min-width: 53.438rem) {
        padding: 1em 1.5em;
        margin: 0;
      }

      > svg {
        > path {
          fill: var(--black);
        }
        > rect {
          fill: #d9d9d9;
        }
      }

      &.router-link-exact-active {
        background: #e8e8e8;
      }
    }

    > a,
    > button {
      span {
        display: none;

        @media screen and (min-width: 53.438rem) {
          display: block;
        }
      }
    }

    > button {
      border: none;
      background: none;
      text-align: left;
      cursor: pointer;
      color: var(--red);
      display: flex;
      gap: 1em;
      align-items: center;
      font-family: var(--font-family), sans-serif;
      font-size: 1em;
      margin: 0;
      padding: 0;

      @media screen and (min-width: 53.438rem) {
        padding: 1rem 2rem;
      }
    }

    > a,
    button {
      padding: 1rem;
    }
  }
}

.profile {
  padding: 0 var(--header-side-padding);
  position: relative;
  display: grid;
  grid-template-columns: 32ch auto;
  grid-template-rows: auto 1fr;
  column-gap: 1em;
  text-align: left;
  min-height: 100vh;

  > span {
    grid-area: 1 / 1;
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0.25rem 1rem;
    text-align: left;
    color: var(--dark-gray-90);
  }

  > nav {
    // grid-area: 2 / 1;
    // display: grid;
    // align-self: start;
    // gap: 0.25rem;

    // > a {
    //   padding: 1rem 2rem;
    //   color: var(--font1);
    //   text-decoration: none;
    //   position: relative;
    //   border-radius: 2rem;
    //   display: flex;
    //   gap: 1rem;
    //   align-items: center;

    //   &.router-link-exact-active {
    //     background-color: #cce1ff;
    //   }
    // }

    // > button {
    //   border: none;
    //   background: none;
    //   padding: 1rem 2rem;
    //   text-align: left;
    //   cursor: pointer;
    //   color: var(--red);
    //   display: flex;
    //   gap: 1rem;
    //   align-items: center;
    //   font-family: var(--font-family);
    //   font-size: 1rem;
    // }
  }

  > .profileSection {
    > h1 {
      margin: 1rem 0 0 0.5rem;
      font-family: var(--font-heading);
      font-style: normal;
      font-weight: 400;
      font-size: 1.875rem;
      margin-left: 0;
    }
  }

  @media screen and (max-width: 53.438rem) {
    padding: 0 0.5rem;
    position: relative;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    column-gap: 0;
    text-align: left;
    margin-top: 5rem;

    > .profileSection {
      grid-area: 2;
      place-self: start stretch;
    }
  }
}
</style>
